/**
 * NAV MIXIN
 * Provides methods to show/hide/toggle a nav.
 * Toggles a `nav-open` class on the <body> to match state of nav.
 */
export const NavMixin = {
    data() {
        return {
            navOpen: false
        }
    },
    methods: {
        openNav() {
            this.navOpen = true;
        },
        closeNav() {
            this.navOpen = false;
        },
        toggleNav() {
            this.navOpen = ! this.navOpen;
        }
    },
    watch: {
        navOpen(isOpen) {
            document.body.classList.toggle('nav-open', isOpen);
        }
    }
}

export default NavMixin;
